import { render, staticRenderFns } from "./ReferenceSelector.vue?vue&type=template&id=2d49dd30&scoped=true"
import script from "./ReferenceSelector.vue?vue&type=script&lang=js"
export * from "./ReferenceSelector.vue?vue&type=script&lang=js"
import style0 from "./ReferenceSelector.vue?vue&type=style&index=0&id=2d49dd30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49dd30",
  null
  
)

export default component.exports